// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyDe9XtyeEVF1ujJrN2pEvX8pplj_WHSDHk',
    authDomain: 'threed-bc539.firebaseapp.com',
    projectId: 'threed-bc539',
    storageBucket: 'threed-bc539.appspot.com',
    messagingSenderId: '614270533022',
    appId: '1:614270533022:web:7064fceb1ed9e8508aaa8f',
    measurementId: 'G-M5JYTWGVR4'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
